/* Sky Kids Modern: playful cart touches + confetti */
(function () {
  if (window.__smPlay) return; window.__smPlay = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#00aeaa', '#fff050', '#ff8fb1', '#7fd6ff', '#ffb347', '#a78bfa'];

  /* ---------- styles ---------- */
  var css = '' +
    '.sm-shoe-hop{position:fixed;z-index:2147483000;pointer-events:none;width:44px;height:44px;margin:-22px 0 0 -22px;will-change:transform}' +
    '@keyframes smBounce{0%,100%{transform:scale(1)}25%{transform:scale(1.35) rotate(-10deg)}50%{transform:scale(.9) rotate(8deg)}75%{transform:scale(1.15)}}' +
    '.sm-cart.sm-bounce{animation:smBounce .7s ease}' +
    '@keyframes smPop{0%{transform:scale(.4)}60%{transform:scale(1.5)}100%{transform:scale(1)}}' +
    '.sm-cart b.sm-pop{animation:smPop .5s ease}' +
    '.sm-toast{position:fixed;left:50%;top:18px;transform:translate(-50%,-140%);z-index:2147483001;background:#0b0b0b;color:#fff;font:500 15px/1.2 Outfit,system-ui,sans-serif;padding:13px 22px;border-radius:100px;box-shadow:0 14px 34px rgba(0,0,0,.25);display:flex;gap:10px;align-items:center;transition:transform .5s cubic-bezier(.2,1.4,.4,1);max-width:calc(100vw - 24px)}' +
    '.sm-toast.show{transform:translate(-50%,0)}.sm-toast i{font-style:normal;font-size:18px}' +
    '.sm-confetti{position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483002}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* ---------- confetti ---------- */
  var canvas, ctx, parts = [], raf = 0;
  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas'); canvas.className = 'sm-confetti';
    document.body.appendChild(canvas); ctx = canvas.getContext('2d'); size();
    window.addEventListener('resize', size);
  }
  function size() { if (!canvas) return; var d = window.devicePixelRatio || 1; canvas.width = innerWidth * d; canvas.height = innerHeight * d; ctx.setTransform(d, 0, 0, d, 0, 0); }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function confetti(x, y, count, spread) {
    if (reduce) return;
    ensureCanvas();
    for (var i = 0; i < count; i++) {
      var a = rand(-Math.PI, 0) + (spread === 'wide' ? 0 : rand(-.3, .3));
      var sp = rand(spread === 'wide' ? 6 : 4, spread === 'wide' ? 15 : 9);
      parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, g: .32, w: rand(6, 11), h: rand(4, 8), r: rand(0, 6), vr: rand(-.3, .3),
        c: COLORS[(Math.random() * COLORS.length) | 0], life: rand(70, 130), round: Math.random() < .3 });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function tick() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    parts = parts.filter(function (p) { return p.life > 0 && p.y < innerHeight + 30; });
    parts.forEach(function (p) {
      p.vy += p.g; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life--;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.globalAlpha = Math.min(1, p.life / 30); ctx.fillStyle = p.c;
      if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.3); ctx.fill(); } else { ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); }
      ctx.restore();
    });
    if (parts.length) { raf = requestAnimationFrame(tick); } else { raf = 0; ctx.clearRect(0, 0, innerWidth, innerHeight); }
  }
  window.smConfetti = confetti;

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(icon, text) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sm-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<i>' + icon + '</i><span></span>'; toastEl.querySelector('span').textContent = text;
    requestAnimationFrame(function () { toastEl.classList.add('show'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 3200);
  }

  /* ---------- cart icon ---------- */
  function cartIcon() { return document.querySelector('.sm-cart'); }
  function setCount(n) {
    var c = cartIcon(); if (!c) return;
    var b = c.querySelector('b');
    if (n > 0) { if (!b) { b = document.createElement('b'); c.appendChild(b); } b.textContent = n; b.classList.remove('sm-pop'); void b.offsetWidth; b.classList.add('sm-pop'); }
    else if (b) { b.remove(); }
    c.setAttribute('aria-label', 'Cart (' + n + ')');
  }
  function refreshCount(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); if (cb) cb(cart); }).catch(function () {});
  }

  /* ---------- hopping shoe ---------- */
  var SHOE = '<svg viewBox="0 0 48 48" width="44" height="44" aria-hidden="true"><path d="M5 31c0-6 4-9 8-9 3 0 4 3 8 3h8c6 0 12 3 14 8v4c0 2-1 3-3 3H8c-2 0-3-1-3-3z" fill="#fff050" stroke="#0b0b0b" stroke-width="2.2" stroke-linejoin="round"/><path d="M5 36h38" stroke="#0b0b0b" stroke-width="2.2"/><path d="M13 22l2-6h7l1 9" fill="#00aeaa" stroke="#0b0b0b" stroke-width="2.2" stroke-linejoin="round"/><circle cx="26" cy="29" r="1.6" fill="#0b0b0b"/><circle cx="32" cy="29" r="1.6" fill="#0b0b0b"/></svg>';
  function hop(fromRect) {
    var c = cartIcon(); if (!c) return;
    var to = c.getBoundingClientRect(), tx = to.left + to.width / 2, ty = to.top + to.height / 2;
    var sx = fromRect ? fromRect.left + fromRect.width / 2 : innerWidth / 2, sy = fromRect ? fromRect.top + fromRect.height / 2 : innerHeight * .7;
    if (reduce) { bounce(c); return; }
    var el = document.createElement('div'); el.className = 'sm-shoe-hop'; el.innerHTML = SHOE; document.body.appendChild(el);
    var lift = Math.max(120, Math.abs(sy - ty) * .35);
    var steps = [0, .25, .5, .75, 1], frames = steps.map(function (t) {
      var x = sx + (tx - sx) * t, y = sy + (ty - sy) * t - Math.sin(Math.PI * t) * lift;
      return { transform: 'translate(' + x + 'px,' + y + 'px) rotate(' + (t * 380) + 'deg) scale(' + (1 + Math.sin(Math.PI * t) * .35 - t * .55) + ')', opacity: t > .92 ? .0 : 1, offset: t };
    });
    var a = el.animate(frames, { duration: 900, easing: 'cubic-bezier(.3,.2,.4,1)' });
    a.onfinish = function () { el.remove(); bounce(c); confetti(tx, ty, 18); };
  }
  function bounce(c) { c.classList.remove('sm-bounce'); void c.offsetWidth; c.classList.add('sm-bounce'); }

  /* ---------- detect add / change via fetch ---------- */
  var lastBtn = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button, a, [role=button]');
    if (!t) return;
    var label = ((t.getAttribute('name') || '') + ' ' + (t.className || '') + ' ' + (t.textContent || '')).toLowerCase();
    if (/add[- ]?to[- ]?(cart|bag)|add-to-cart/.test(label) || t.matches('[name=add]')) { lastBtn = t; }
    if (t.matches('[name=checkout], a[href*="/checkout"]') || /(^|\s)(check ?out)(\s|$)/.test(label)) {
      try { localStorage.setItem('smCheckoutStarted', String(Date.now())); } catch (er) {}
    }
  }, true);
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var rect = lastBtn ? lastBtn.getBoundingClientRect() : null;
      p.then(function (res) { if (res && res.ok) { refreshCount(function () { hop(rect); toast('🎉', 'Added to your bag!'); }); } }).catch(function () {});
    } else if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { refreshCount(); }).catch(function () {});
    }
    return p;
  };

  /* ---------- celebrate on return after paying ---------- */
  function checkReturn() {
    var ts; try { ts = +localStorage.getItem('smCheckoutStarted'); } catch (e) {}
    if (!ts) return;
    if (Date.now() - ts > 2 * 3600 * 1000) { try { localStorage.removeItem('smCheckoutStarted'); } catch (e) {} return; }
    if (/\/checkouts?\//.test(location.pathname)) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count === 0) {
        try { localStorage.removeItem('smCheckoutStarted'); } catch (e) {}
        toast('🎉', 'Thank you! Your order is on its way.');
        confetti(innerWidth * .25, innerHeight * .7, 70, 'wide'); confetti(innerWidth * .75, innerHeight * .7, 70, 'wide');
        setTimeout(function () { confetti(innerWidth * .5, innerHeight * .6, 90, 'wide'); }, 350);
      }
    }).catch(function () {});
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', checkReturn); } else { checkReturn(); }
  window.smPlay = { hop: hop, toast: toast, confetti: confetti, setCount: setCount };
})();
